import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import selectorExample3 from './assets/images/selector-example3.png';
import selectorExample4 from './assets/images/selector-example4.png';
import selectorExample5 from './assets/images/selector-example5.png';
import selectorExample6 from './assets/images/selector-example6.png';

const CSSLesson11 = () => {
  const [language, changeLanguage] = useState("css");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
   <h1 style="color: blue;"> A Blue Heading. </h1>
   <p style="color: red;"> A Red paragraph. </p>
  `
  );
  const code1 = (
  'text',
  `
   <!DOCTYPE html>
   <html>
   <head>
   <style>
   body {background-color: powderblue;}
   h1 {color: blue;}
   </style>
   </head>
   <body>
   <h1>This is a heading</h1>
   <p>This is a paragraph</p>
   </body>
   </html>
  `
  );
  const code2 = (
  'text',
  `
   <!DOCTYPE html>
   <html>
   <head>
   <link rel="stylesheet" href="style.css"/>
   </head>
   <body>
   <h1>This is a heading</h1>
   <p>This is a paragraph</p>
   </body>
   </html>
  `
  );
  const code3 = (
  'text',
  `
  body {
    background-color: powderblue;
  }
  h1 {
    color: blue;
  }
  p {
    color: red;
  }
  `
  );


  return (
    <HTMLCourseNavProvider>
      <div className="container">
        <div className="row">
          <div>
            <SideBar />
          </div>
    
          <h3><strong>How to use CSS</strong></h3>

     <p>CSS can be added to HTML documents in any of the 3 ways:</p>
     <div className="alert alert-secondary" role="alert">

     <ol class="list-group list-group-numbered mb-4">
      <li class="list-group-item"><b>Inline:</b> by using the <b class="text-danger">style</b> attribute inside HTML elements</li>
      <li class="list-group-item"><b>Internal:</b> by using a <b class="text-danger">&lt;style&gt;</b> element in the &lt;head&gt; section</li>
      <li class="list-group-item"><b>External:</b> by using a <b class="text-danger">&lt;link&gt;</b> element to link to an external CSS file</li>
    </ol>
    </div>
    <br/>
    <div className="alert alert-secondary" role="alert">
    <h4><strong>Inline CSS</strong></h4>
    <p>An inline CSS is used to apply a unique style to a single HTML element.</p>
    <p>An inline CSS uses the <b class="text-danger">&lt;style&gt;</b> attribute of an HTML element.</p>
    <p>An inline CSS applied to an element will override any other already existing style.</p>

    <CopyBlock
    language={language}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>
    <br/>
    <div className="alert alert-secondary" role="alert">
    <h4><strong>Internal CSS</strong></h4>
    <p>internal CSS is used to define a style for a single HTML page.</p>
    <p>An internal CSS is defined in the <b class="text-danger">&lt;head&gt;</b> section of an HTML page, within a <b>&lt;style&gt;</b> element.</p>

    <CopyBlock
    language={'html'}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    
    </div>
           <br/>
           <div className="alert alert-secondary" role="alert">
           <h4><strong>External CSS</strong></h4>
    <p>An external style sheet is used to define the style for many HTML pages.</p>
    <p>To use an external style sheet, add a link to it in the <b class="text-danger">&lt;head&gt;</b> section of each HTML page</p>

    <CopyBlock
    language={'html'}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br/>
    <p>Then to your CSS File, you have this code below.</p>
    <CopyBlock
    language={'css'}
    text={code3}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>
         


          </div>
        </div>
    </HTMLCourseNavProvider>
  );
};

export default CSSLesson11;
